import { HeadAndNeckDashboard } from "./dashboard";
import { HeadAndNeckFilters } from "./filters";
import * as React from "react";

export { HeadAndNeckFilters }


export class HeadAndNeckDashboardHome extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            width: 0,
            height: 0
        };       

    }

    private updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
      };
    
    public componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }
       
    public componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    render = () => {
        return (
            <>
                <HeadAndNeckDashboard />
                </>
        )

    }
}